interface IProps {
  stroke?: string
  fill?: string
}

export default function IconValueUp({ fill = '#121212' }: IProps) {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.6666 4L12.1933 5.52667L8.93992 8.78L6.27325 6.11333L1.33325 11.06L2.27325 12L6.27325 8L8.93992 10.6667L13.1399 6.47333L14.6666 8V4H10.6666Z'
        fill={fill}
      />
    </svg>
  )
}
